import { Injectable, inject } from '@angular/core';
// import { Actions, Effect, ofType } from '@ngrx/effects';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import {
	ActionTypes,
	GetCustomerOrders,
	GetCustomerOrdersError,
	GetCustomerOrdersSuccess,
	CheckDeliverystatus,
	CheckDeliverystatusError,
	CheckDeliverystatusSuccess,
	CancelItemOrder,
	CancelItemOrderSuccess,
	CancelItemOrderError,
	GetItemOrderId,
	GetItemOrderIdSuccess,
	GetItemOrderIdError,
	GetCustomerItemDocketStatus,
	GetCustomerItemDocketStatusSuccess,
	GetCustomerItemDocketStatusError,
	OrderPostComment,
	OrderPostCommentError,
	OrderPostCommentSuccess,
	OrderReview,
	OrderReviewSuccess,
	OrderReviewError
} from "./order.actions";
import { Helper } from "../../shared/services/Helper.service";
import { MatDialog } from "@angular/material/dialog";
import { AlertPopupService } from "../../shared/services/alert-popup.service";
import { OrderService } from 'src/app/shared/services/order.service';
import { Router } from '@angular/router';

@Injectable()
export class OrderEffects {

	// @Effect()
	// GetCustomerOrders$ = this.actions$.pipe(
	GetCustomerOrders$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCustomerOrders),
			map((action: GetCustomerOrders) => action.payload),
			mergeMap((payload) => {
				console.log('Attempting to fetch orders', payload);
				return this.orderService.GetCustomerOrders(payload).pipe(
					map((response: any) => {
						console.log('API Response', response);
						return new GetCustomerOrdersSuccess(response);
					}),
					catchError((error) => {
						console.error('API Error', error);
						return of(new GetCustomerOrdersError(error));
					})
				);
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetCustomerOrdersSuccess$ = this.actions$.pipe(
	GetCustomerOrdersSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCustomerOrdersSuccess),
			map((action: GetCustomerOrdersSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetCustomerOrdersError$ = this.actions$.pipe(
	GetCustomerOrdersError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCustomerOrdersError),
			map((action: GetCustomerOrdersError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// CheckDeliverystatus$ = this.actions$.pipe(
	CheckDeliverystatus$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CheckDeliverystatus),
			map((action: CheckDeliverystatus) => action.payload),
			mergeMap((payload) => {
				return this.orderService.GetDeliveryStatus(payload).pipe(
					map((response: any) => {
						return new CheckDeliverystatusSuccess(response);
					}),
					catchError((error) => {
						console.error('API Error', error);
						return of(new CheckDeliverystatusError(error));
					})
				);
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CheckDeliverystatusSuccess$ = this.actions$.pipe(
	CheckDeliverystatusSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CheckDeliverystatusSuccess),
			map((action: GetCustomerOrdersSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CheckDeliverystatusError$ = this.actions$.pipe(
	CheckDeliverystatusError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CheckDeliverystatusError),
			map((action: GetCustomerOrdersError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetItemOrderId$ = this.actions$.pipe(
	GetItemOrderId$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemOrderId),
			map((action: GetItemOrderId) => action.payload),
			mergeMap((payload) => {
				console.log('Attempting to fetch orders', payload);
				return this.orderService.GetItemOrderId(payload.id).pipe(
					map((response: any) => {
						console.log('API Response', response);
						return new GetItemOrderIdSuccess(response);
					}),
					catchError((error) => {
						console.error('API Error', error);
						return of(new GetItemOrderIdError(error));
					})
				);
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetItemOrderIdSuccess$ = this.actions$.pipe(
	GetItemOrderIdSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemOrderIdSuccess),
			map((action: GetItemOrderIdSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetItemOrderIdError$ = this.actions$.pipe(
	GetItemOrderIdError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetItemOrderIdError),
			map((action: GetItemOrderIdError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// CancelItemOrder$ = this.actions$.pipe(
	CancelItemOrder$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CancelItemOrder),
			map((action: CancelItemOrder) => action.payload),
			mergeMap((payload) => {
				console.log('Attempting to fetch orders', payload);
				return this.orderService.CancelItemOrder(payload).pipe(
					map((response: any) => {
						console.log('API Response', response);
						return new CancelItemOrderSuccess(response);
					}),
					catchError((error) => {
						console.error('API Error', error);
						return of(new CancelItemOrderError(error));
					})
				);
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CancelItemOrderSuccess$ = this.actions$.pipe(
	CancelItemOrderSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CancelItemOrderSuccess),
			map((action: CancelItemOrderSuccess) => action.payload),
			mergeMap((payload) => {
				this.alertPopupService.showInfoAlert('Order Cancel sucessfully.');
				this.dialog.closeAll();
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CancelItemOrderError$ = this.actions$.pipe(
	CancelItemOrderError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CancelItemOrderError),
			map((action: CancelItemOrderError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetCustomerItemDocketStatus$ = this.actions$.pipe(
	GetCustomerItemDocketStatus$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCustomerItemDocketStatus),
			map((action: GetCustomerItemDocketStatus) => action.payload),
			mergeMap((payload) => {
				console.log('Attempting to fetch orders', payload);
				return this.orderService.GetCustomerItemDocketStatus(payload.docketId).pipe(
					map((response: any) => {
						console.log('API Response', response);
						return new GetCustomerItemDocketStatusSuccess(response);
					}),
					catchError((error) => {
						console.error('API Error', error);
						return of(new GetCustomerItemDocketStatusError(error));
					})
				);
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetCustomerItemDocketStatusSuccess$ = this.actions$.pipe(
	GetCustomerItemDocketStatusSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCustomerItemDocketStatusSuccess),
			map((action: GetCustomerItemDocketStatusSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetCustomerItemDocketStatusError$ = this.actions$.pipe(
	GetCustomerItemDocketStatusError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetCustomerItemDocketStatusError),
			map((action: GetCustomerItemDocketStatusError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// OrderPostComment$ = this.actions$.pipe(
	OrderPostComment$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.OrderPostComment),
			map((action: OrderPostComment) => action.payload),
			mergeMap((payload) => {
				return this.orderService.PostComment(payload.orderId, payload.payload).pipe(
					map((response: any) => {
						if (payload.isPaymentPage) {
							this.router.navigate(['/']);
						}
						return new OrderPostCommentSuccess(response)
					}),
					catchError((error) => of(new OrderPostCommentError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// OrderPostCommentSuccess$ = this.actions$.pipe(
	OrderPostCommentSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.OrderPostCommentSuccess),
			map((action: OrderPostCommentSuccess) => action.payload),
			mergeMap((payload) => {
				this.alertPopupService.showInfoAlert('Order Reviewd sucessfully.');
				this.dialog.closeAll();
				return of()
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// OrderPostCommentError$ = this.actions$.pipe(
	OrderPostCommentError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.OrderPostCommentError),
			map((action: OrderPostCommentError) => action.payload),
			mergeMap((payload) => {
				if (payload.error?.error?.message === 'Already Exists')
					this.alertPopupService.showInfoAlert('Thanks, you have already provided review for this order');
				else
					this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// OrderReview$ = this.actions$.pipe(
	OrderReview$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.OrderReview),
			map((action: OrderReview) => action.payload),
			mergeMap((payload) => {
				console.log('Attempting to fetch orders', payload);
				return this.orderService.OrderReview(payload).pipe(
					map((response: any) => {
						console.log('API Response', response);
						return new OrderReviewSuccess(response);
					}),
					catchError((error) => {
						console.error('API Error', error);
						return of(new OrderReviewError(error));
					})
				);
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// OrderReviewSuccess$ = this.actions$.pipe(
	OrderReviewSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.OrderReviewSuccess),
			map((action: OrderReviewSuccess) => action.payload),
			mergeMap((payload) => {
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// OrderReviewError$ = this.actions$.pipe(
	OrderReviewError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.OrderReviewError),
			map((action: OrderReviewError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null);
			})
		)
	}, { dispatch: false });
	// );

	constructor(
		private actions$: Actions,
		private helper: Helper,
		private orderService: OrderService,
		private dialog: MatDialog,
		private router: Router,
		private alertPopupService: AlertPopupService,
	) {
	}
}
